import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {FmlxIcon, FmlxTooltip} from 'fmlx-common-ui';
import FastDrawer from 'components/FastDrawer/FastDrawer';
import withIntl from '../../lib/withIntl';

import './SideMenu.scss';

class SideMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userExpanded: false,
      expandedIndex: -1,
    };
  }

  // eslint-disable-next-line react/no-unused-class-component-methods
  expandUserMenu = () => {
    const {userExpanded} = this.state;
    this.setState({userExpanded: !userExpanded});
  };

  expandMenu = (expandedIndexParam) => {
    const {expandedIndex} = this.state;
    if (expandedIndexParam !== expandedIndex) this.setState({expandedIndex: expandedIndexParam});
    else this.setState({expandedIndex: -1});
  };

  render() {
    const {expandedIndex} = this.state;
    const {title, closeLabel, menuList, showDrawer, onDrawerBlur, intl} = this.props;
    const menuListComponents = [];
    for (let iMenuList = 0; iMenuList < menuList.length; iMenuList += 1) {
      const menu = menuList[iMenuList];
      if (!menu.hidden) {
        if (menu.title === '') {
          menuListComponents.push(<div key={iMenuList} className="separator" />);
        } else if (menu.subMenuList) {
          const subMenuListComponents = [];

          for (let j = 0; j < menu.subMenuList.length; j += 1) {
            const subMenu = menu.subMenuList[j];

            if (!subMenu.hidden) {
              subMenuListComponents.push(
                <button
                  type="button"
                  key={j}
                  className={`item child ${subMenu.selected ? 'selected' : ''} ${subMenu.disabled ? 'disabled' : ''}`}
                  onClick={subMenu.onClick}
                  disabled={subMenu.disabled}
                >
                  {subMenu.icon ? (
                    <img
                      className="icon"
                      alt={`./svg/side-menu-icon/${subMenu.icon}${subMenu.disabled ? '-disabled' : ''}.svg`}
                      src={`./svg/side-menu-icon/${subMenu.icon}${subMenu.disabled ? '-disabled' : ''}.svg`}
                    />
                  ) : null}
                  <FmlxTooltip
                    title={`${subMenu.disabled ? intl.formatMessage({id: subMenu.tootlipMessage || 'sideMenuContainer.disabledMenu.demoOnly.tooltip'}) : ''}`}
                    placement="right"
                  >
                    <span>{subMenu.title}</span>
                  </FmlxTooltip>
                </button>,
              );
            }
          }

          menuListComponents.push(
            <React.Fragment key={iMenuList}>
              <button
                type="button"
                className={`item parent ${expandedIndex === iMenuList ? 'expanded' : 'collapsed'} ${menu.disabled ? 'disabled' : ''}`}
                onClick={() => this.expandMenu(iMenuList)}
                disabled={menu.disabled}
              >
                <FmlxTooltip
                  title={`${menu.disabled && menu.tootlipMessage ? intl.formatMessage({id: menu.tootlipMessage}) : ''}`}
                  placement="right"
                >
                  <div className="menu-container">
                    <div style={{display: 'flex', alignItems: 'center'}}>
                      {menu.icon && (
                        <img
                          className="icon"
                          alt={`./svg/side-menu-icon/${menu.icon}${menu.disabled ? '-disabled' : ''}.svg`}
                          src={`./svg/side-menu-icon/${menu.icon}${menu.disabled ? '-disabled' : ''}.svg`}
                        />
                      )}
                      {menu.glyph && <span className={`item-icons ${menu.glyph}`} />}
                      <span className="menu-title">{menu.title}</span>
                    </div>
                    <div>
                      <FmlxIcon
                        className="item-icons-caret"
                        name={expandedIndex === iMenuList ? 'ChevronDown' : 'ChevronRight'}
                        customColor={menu.disabled ? '#c2c2c2' : 'white'}
                        size="md"
                      />
                    </div>
                  </div>
                </FmlxTooltip>
              </button>
              <div className={`item-child-container ${expandedIndex === iMenuList ? 'expanded' : 'collapsed'}`}>
                {subMenuListComponents}
              </div>
            </React.Fragment>,
          );
        } else {
          menuListComponents.push(
            <button
              type="button"
              key={iMenuList}
              className={`item ${menu.selected ? 'selected' : ''} ${menu.disabled ? 'disabled' : ''}`}
              onClick={menu.onClick}
              disabled={menu.disabled}
            >
              {menu.icon ? (
                <img
                  className="icon"
                  alt={`./svg/side-menu-icon/${menu.icon}${menu.disabled ? '-disabled' : ''}.svg`}
                  src={`./svg/side-menu-icon/${menu.icon}${menu.disabled ? '-disabled' : ''}.svg`}
                />
              ) : (
                <span className="icon" />
              )}
              <FmlxTooltip
                title={`${menu.disabled && !menu.hideNoLicenseTooltip ? intl.formatMessage({id: menu.tootlipMessage || 'sideMenuContainer.disabledMenu.demoOnly.tooltip'}) : ''}`}
                placement="right"
              >
                <span style={{width: '100%', textAlign: 'left'}}>{menu.title}</span>
              </FmlxTooltip>
            </button>,
          );
        }
      }
    }
    return (
      <FastDrawer drawerSide="left" show={showDrawer} onDrawerBlur={onDrawerBlur} className="side-menu">
        <div id="menu-content" className="block-scrollable">
          <div className="item title">
            <img
              className="icon"
              alt="side-menu-formulatrix-icon"
              src="./svg/side-menu-icon/side-menu-formulatrix-icon.svg"
            />
            <h4>{title}</h4>
          </div>
          <button type="button" className="item close-btn" onClick={onDrawerBlur}>
            <span>
              <FmlxIcon name="ChevronLeft" customColor="white" />
            </span>
            <span>{closeLabel}</span>
          </button>
          {menuListComponents}
        </div>
      </FastDrawer>
    );
  }
}

SideMenu.propTypes = {
  intl: PropTypes.any.isRequired,
  title: PropTypes.string.isRequired,
  closeLabel: PropTypes.string.isRequired,
  menuList: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      onClick: PropTypes.func,
      selected: PropTypes.bool,
      hidden: PropTypes.bool,
      icon: PropTypes.string,
      glyph: PropTypes.string,
      subMenuList: PropTypes.array,
      disabled: PropTypes.bool,
      hideNoLicenseTooltip: PropTypes.bool,
      tootlipMessage: PropTypes.string,
    }),
  ).isRequired,
  showDrawer: PropTypes.bool.isRequired,
  onDrawerBlur: PropTypes.func.isRequired,
};

export default withIntl(SideMenu);
